import queryString from "app/services/queryStringService";
import { memo, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import { Breadcrumb } from "@gull";
import { addUpdateVendor, getVendorList } from "app/services/vendorService";
import {
  Button,
  Col,
  Dropdown,
  DropdownButton,
  Form,
  Image,
  Row,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { MdAddBox, MdEdit, MdSearch } from "react-icons/md";
import moment from "moment";
import SupplierAddUpdate from "./Components/SupplierAddUpdate";
import Swal from "sweetalert2";
import Tooltip from "rc-tooltip";
import { NotificationManager } from "react-notifications";
import SupplierJourneyType from "./Components/SupplierJourneyType";

const SupplierList = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [userSearch, setUserSearch] = useState("");
  const [initialValues, setInitialValues] = useState({
    id: 0,
    supplierName: "",
    supplierType: "FLIGHT",
    supplierCode: "",
    supplierDescription: "",
    supplierApiType: "BUNDLE",
    supplierActiveStatus: true,
    internationalReturn: true,
    domesticReturn: true,
    domesticOneway: true,
    internationalOneway: true,
  });

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showSupplierJourneyType, setShowSupplierJourneyType] = useState(false);

  const handleCloseSupplierJourneyType = () =>
    setShowSupplierJourneyType(false);
  const handleShowSupplierJourneyType = () => setShowSupplierJourneyType(true);

  const handelSupplierJourneyType = (row) => {
    handleShowSupplierJourneyType();
    setInitialValues(row);
  };

  const dateFormatter = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <div>
        <div>{moment(cell).format("DD-MM-YYYY")}</div>
        <div>{moment(cell).format("HH:mm a")}</div>
      </div>
    );
  };
  const statusFormatter = (cell, row) => {
    return (
      <div className="row align-items-center d-flex justify-content-center">
        <div className="col-auto text-red">
          <span
            style={{
              color: row.supplierActiveStatus == false && "red",
            }}
          >
            Deactivate
          </span>
        </div>
        <div className="col-auto">
          <div
            className="d-flex justify-content-center"
            // style={{ cursor: "pointer" }}
          >
            <Tooltip
              placement="top"
              overlay={
                row.supplierActiveStatus === false
                  ? "Click to activate"
                  : "Click to deactivate"
              }
            >
              <span>
                <Form.Check
                  type="switch"
                  id={`custom-switch${row.id}`}
                  checked={row.supplierActiveStatus}
                  onChange={() => updateDefaultApi(row)}
                />
              </span>
            </Tooltip>
          </div>
        </div>
        <div className="col-auto">
          <div
            style={{
              color: row.supplierActiveStatus !== false ? "green" : "inherit",
            }}
          >
            Activate
          </div>
        </div>
      </div>
    );
  };
  const gatewayFormatter = (cell, row) => {
    return cell == "TRAVELPORT_GAL" ? "TRAVELPORT GAL" : cell;
  };
  const updateDefaultApi = async (row) => {
    Swal.fire({
      title: ` Are you sure you want to ${
        row.supplierActiveStatus == true ? "deactivate " : "activate"
      } the Supplier?`,
      icon: "warning",
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
    }).then(async (result) => {
      if (result.value) {
        let data = {
          ...row,
          supplierActiveStatus: !row.supplierActiveStatus,
        };

        try {
          const response = await addUpdateVendor(data);
          if (response.status == "Success") {
            NotificationManager.success(response.message);
          } else {
            NotificationManager.success("Something Went to be Wrong");
          }
        } catch (error) {
          NotificationManager.success("Something Went to be Wrong");
        }
        // }
        loadVendorList();
      } else {
        Swal.fire({
          title: "Cancelled!",
          text: "Permission denied.",
          type: "error",
          icon: "error",
          timer: 1500,
        });
      }
    });
  };
  const actionFormatter = (cell, row) => {
    return (
      <>
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item
            onClick={() => handelSupplierJourneyType(row)}
            disabled={!row?.supplierActiveStatus}
          >
            <MdEdit
              className="text-primary me-4"
              size={15}
              //   style={{ marginLeft: "-70%" }}
            ></MdEdit>
            Journey Type Mapping
          </Dropdown.Item>
        </DropdownButton>
      </>
    );
  };

  const columns = [
    {
      dataField: "supplierEntryDate",
      text: "Created On",
      headerStyle: (column, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "supplierModifyDate",
      text: "Modified On",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: dateFormatter,
    },

    {
      dataField: "supplierName",
      text: "Name",
      headerStyle: (column, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: gatewayFormatter,
    },
    {
      dataField: "supplierCode",
      text: "Code",
      headerStyle: (column, colIndex) => {
        return { textAlign: "center" };
      },
      //   formatter: fareCommissionStatusFormatter,
    },
    {
      dataField: "supplierActiveStatus",
      text: "Status",
      headerStyle: (column, colIndex) => {
        return { textAlign: "center", width: "300px" };
      },
      formatter: statusFormatter,
    },
    {
      dataField: "supplierType",
      text: "Type",
      headerStyle: (column, colIndex) => {
        return { textAlign: "center" };
      },
      //   formatter: ServiceList,
    },
    {
      dataField: "supplierApiType",
      text: "Api Type",
      headerStyle: (column, colIndex) => {
        return { textAlign: "center" };
      },
      //   formatter: ServiceList,
    },
    {
      dataField: "id",
      text: "Action",
      headerStyle: (column, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";

    return style;
  };
  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadVendorList = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      userSearch,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getVendorList(query);
    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };
  useEffect(() => {
    loadVendorList();
  }, [page, sizePerPage, userSearch]);
  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
    // setTimeout(async () => {
    //   await loadVendorList();
    // }, 10);
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;

    if (name == "userSearch") setUserSearch(value);
    setTimeout(async () => {
      await loadVendorList();
    }, 10);
  };
  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setTimeout(async () => {
      await loadVendorList();
    }, 10);
  };

  const refreshFilter = async (e) => {
    setUserSearch("");
    setTimeout(async () => {
      await loadVendorList();
    }, 10);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size </label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 10,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Button
        className="btn-md float-end"
        variant="primary"
        onClick={handleShow}
      >
        <MdAddBox size={20} /> Add Supplier
      </Button>
      <Helmet>
        <title>Supplier List</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Supplier List" }]}></Breadcrumb>
      <div className="card card-body mb-3 ">
        <Row className="mb-2">
          <Col lg={10} xs={12}>
            {/* <Form.Select aria-label="Default select example">
              <option value="1">GROUP A</option>
              <option value="2">GROUP B</option>
              <option value="3">GROUP c</option>
            </Form.Select> */}
          </Col>
          <Col lg={2} xs={12}>
            <div className="d-flex justify-content-end  ">
              <button
                className="btn btn-outline-primary d-flex align-items-center ms-3"
                onClick={refreshFilter}
              >
                Refresh
              </button>
            </div>
          </Col>
        </Row>

        <div style={{ overflow: "auto" }}>
          <BootstrapTable
            hover
            remote
            keyField="uniqueIdentity"
            data={data}
            columns={columns}
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </div>
      <SupplierAddUpdate
        show={show}
        handleClose={handleClose}
        initialValues={initialValues}
        setInitialValues={setInitialValues}
        loadVendorList={loadVendorList}
      />
      <SupplierJourneyType
        show={showSupplierJourneyType}
        handleClose={handleCloseSupplierJourneyType}
        initialValues={initialValues}
        setInitialValues={setInitialValues}
        loadVendorList={loadVendorList}
      />
    </>
  );
};

export default memo(SupplierList);
